import { useStore } from '@nanostores/react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { PrivateBetaScreen } from './PrivateBetaScreen';
import { NoDatabaseScreen } from '~/components/ui/shadcn/components/supabase-manager/NoDatabaseScreen';
import { UsersManager } from '~/components/ui/shadcn/components/supabase-manager/Users.client';
import { supabaseStore } from '~/lib/stores/supabase';
import { userStore } from '~/lib/stores/user';

const queryClient = new QueryClient();

export const UserManagementView = () => {
  const supabaseStatus = useStore(supabaseStore.supabaseStatus);
  const featureFlags = useStore(userStore.featureFlags);
  const project = useStore(supabaseStore.supabaseProject);
  const projectId = project?.id;

  if (!featureFlags.supabaseManagement) {
    return (
      <PrivateBetaScreen
        icon="i-bolt:user-management"
        title="Your userbase at a glance"
        description="View user signups over time, and understand deeper how they interact with your application."
      />
    );
  }

  if (supabaseStatus !== 'CONFIGURED' || !projectId) {
    return (
      <NoDatabaseScreen
        icon="i-bolt:user-management"
        description="You need a database to view user sign-ups over time directly from your project settings."
      />
    );
  }

  return (
    <QueryClientProvider client={queryClient}>
      <UsersManager />
    </QueryClientProvider>
  );
};
